import { CSSObject } from '@mantine/core';
import { textVariants } from '@ui/tokens/typography/typography';
import { MantineThemeComponent } from '../../types';

const SelectDefaultConfig: MantineThemeComponent = {
	defaultProps: {
		drop: 'bottom-start'
	},
	styles: {
		input: {
			...( textVariants.body as CSSObject ),
			'color': 'black',
			'border': '1px solid var(--mantine-color-gray-4)',
			'backgroundColor': '#FBFBFB',
			'borderRadius': '4px',
			'padding': '4px 8px',
			'height': '44px',
			'&::placeholder': {
				...( textVariants.body as CSSObject )
			}
		},
		label: {
			...( textVariants[ 'body-bold' ] as CSSObject ),
			marginBottom: 8
		},
		item: {
			...( textVariants.body as CSSObject ),
			'color': 'black'
		},
		dropdown: {
			'border': '1px solid var(--mantine-color-gray-4)',
			'marginTop': -4,
			'borderRadius': '4px'
		}
	}
};

export default SelectDefaultConfig;
